import React, { useState, useEffect } from "react";
import ValidatePan from "./ValidatePan";
import ActiveUserInfo from "./ActiveUserInfo";
import CheckPrevRequest from "./CheckPrevRequest";
import Digilocker from "./Digilocker";
import CreateRequest from "./CreateRequest";
import AddressProofModification from "./AddressProofModification";
import AddressInfoModification from "./AddressInfoModification";
import CommunicationAddressForm from "./CommunicationAddressForm";
import PermanentAddressForm from "./PermanentAddressForm";
import AddressModificationReason from "./AddressModificationReason";
import AddressModificationReview from "./AddressModificationReview";
import AddressModificationESignature from "./AddressModificationESignature";
import Loader from "designs/v1/pages/ModifyKyc/components/Loader";
import DematUccForm from "../DematUccForm";
import {
  getRequestTypeDocs,
  getUccDematDetailApi,
  addressUccDematApi,
  createDgLockerApi,
  getActiveUserDetailsApi,
  getDataFormDglockerApi,
} from "designs/v1/pages/ModifyKyc/services";

const AddressModification = ({ stageScreen, setStageScreen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [requestData, setRequestData] = useState(null);
  const [step, setStep] = useState("ValidatePan");
  const [isDigilocker, setIsDigilocker] = useState(false);
  const [isContinue, setIsContinue] = useState(false);
  const [activeUserDetail, setActiveUserDetail] = useState(null);

  useEffect(() => {
    const isDigilocker = localStorage.getItem("isDigilocker");
    const getUserDetail = async () => {
      const user = JSON.parse(sessionStorage.getItem("user") || {});
      const userPayload = {
        mobile_no: user.entity,
        pan_no: user.pan,
      };
      try {
        const resp = await getActiveUserDetailsApi(userPayload);
        setActiveUserDetail(resp.data.data?.request_number);
        localStorage.removeItem("isDigilocker");
        try {
          const payload = {
            doc_name: localStorage.getItem("AddressRequestNumber"),
          };
          const resp = await getDataFormDglockerApi(payload);
          const data = resp.data?.data;
          setIsLoading(false);
          if (data?.data_fetched_from_digilocker) {
            if (
              localStorage.getItem("AddressRequestType") ===
              "Permanent Address Modification"
            ) {
              setStep("PermanentAddressForm");
            } else {
              setStep("AddressInfoModification");
            }
          } else {
            setStep("AddressProofModification");
          }
        } catch (error) {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        localStorage.removeItem("isDigilocker");
      }
    };
    if (isDigilocker) {
      getUserDetail();
    }
  }, []);

  useEffect(() => {
    const requestType = getRequestTypeDocs();
    const loadUccDematDetail = async () => {
      const payload = {
        document_name: requestType[0],
      };
      try {
        const resp = await getUccDematDetailApi(payload);
        const data = resp.data?.data;
        handleUccDemat(data);
      } catch (err) {
        console.log("err", err);
      }
    };
    if (requestType?.length && step === "DematUccForm") {
      loadUccDematDetail();
    }
  }, [step]);

  const handleBack = () => setStep("ActiveUserInfo");

  const handleUccDemat = async (formVal) => {
    setIsLoading(true);
    const payload = {
      request_type: stageScreen,
      document_name: localStorage.getItem("AddressRequestNumber"),
      address_type: localStorage.getItem("AddressRequestType"),
      ...formVal,
    };
    try {
      const resp = await addressUccDematApi(payload);
      console.log("resp", resp);
      setIsLoading(false);
      if (
        localStorage.getItem("AddressRequestType") ===
        "Communication Address Modification"
      ) {
        setStep("CommunicationAddressForm");
      } else if (isDigilocker) {
        try {
          const resp = await createDgLockerApi({
            doc_name: localStorage.getItem("AddressRequestNumber"),
          });
          console.log("resp", resp);
          setIsLoading(false);
          window.location.href = resp?.data?.data?.url;
        } catch (error) {
          setIsLoading(false);
        }
      } else {
        setStep("AddressProofModification");
      }
    } catch (error) {
      console.log("err", error);
      setIsLoading(false);
    }
  };

  const getStepScreen = (step) => {
    let html = null;
    switch (step) {
      case "ValidatePan":
        html = (
          <ValidatePan
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setActiveUserDetail={setActiveUserDetail}
          />
        );
        break;
      case "ActiveUserInfo":
        html = (
          <ActiveUserInfo
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            activeUserDetail={activeUserDetail}
          />
        );
        break;
      case "CheckPrevRequest":
        html = (
          <CheckPrevRequest
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            setIsContinue={setIsContinue}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            activeUserDetail={activeUserDetail}
          />
        );
        break;
      case "DematUccForm":
        html = (
          <DematUccForm
            activeUserDetail={activeUserDetail}
            isLoading={isLoading}
            handleBack={handleBack}
            handleSubmit={handleUccDemat}
          />
        );
        break;
      case "Digilocker":
        html = (
          <Digilocker
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setRequestData={setRequestData}
            setIsDigilocker={setIsDigilocker}
          />
        );
        break;
      case "CreateRequest":
        html = (
          <CreateRequest
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            requestData={requestData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        );
        break;
      case "AddressProofModification":
        html = (
          <AddressProofModification
            activeUserDetail={activeUserDetail}
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        );
        break;
      case "AddressInfoModification":
        html = (
          <AddressInfoModification
            activeUserDetail={activeUserDetail}
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        );
        break;
      case "CommunicationAddressForm":
        html = (
          <CommunicationAddressForm
            activeUserDetail={activeUserDetail}
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        );
        break;
      case "PermanentAddressForm":
        html = (
          <PermanentAddressForm
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            activeUserDetail={activeUserDetail}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        );
        break;
      case "AddressModificationReason":
        html = (
          <AddressModificationReason
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isContinue={isContinue}
            setIsContinue={setIsContinue}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            activeUserDetail={activeUserDetail}
          />
        );
        break;
      case "AddressModificationReview":
        html = (
          <AddressModificationReview
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        );
        break;
      case "AddressModificationESignature":
        html = (
          <AddressModificationESignature
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        );
        break;
      default:
        break;
    }
    return html;
  };
  return (
    <React.Fragment>
      {isLoading && <Loader />}
      {getStepScreen(step)}
    </React.Fragment>
  );
};

export default AddressModification;
